import { Method } from '../types';

// return translation string
export const getAnalysesMethodDescription = (method: Method) => {
  if ([Method.WineConz, Method.Yeast2Conz, Method.BioEthConz].includes(method))
    return 'method.onlyConcentration';
  if (
    [Method.WineConzViab, Method.Yeast2ConzViab, Method.BioEthConzViab].includes(method)
  )
    return 'method.concentrationAndViability';
  return '';
};
